import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["agreement-modal"];

  checkAgreement(e) {
    this.agreementModalOutlet.requireAgreement(e);
  }
}
